// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_fk","advertDetailContacts__header":"c-n_fl"};